export const SESSION_STORAGE_KEYS = {
  SESSION_ID: 'sessionId',
  TRACE_ID: 'traceId',
  INIT_CLIENT: 'initClient',
  /** CLI device code carried from the MT login leg, so the ST landing can adopt it
   *  (init_login adopt_user_code) and auto-confirm the device session without re-typing. */
  USER_CODE: 'userCode',
  LAST_REDIRECT: 'lastRedirect',
  OIDC_CODE_VERIFIER: 'oidcCodeVerifier',
  SIGNUP_EVENT_FIRED: 'signup_event_fired',
  DID_AUTO_OPEN_FOR_EXPIRED_TRIAL_USER: 'expired_trial_autoopen',
  DID_CHUNK_RELOAD: 'did_chunk_reload_already',
  /** Integration whose connect flow is in progress; set before the OAuth tab
   *  opens, consumed back on the integrations page to refetch the connection
   *  status so the Connected badge appears without a manual reload. Per-tab so a
   *  concurrent connect in another tab can't clobber or prematurely clear it. */
  PENDING_INTEGRATION_CONNECT: 'pendingIntegrationConnect',
  /** Set when the user dismisses or engages with the migration welcome popup.
   *  Cleared on logout (sessionStorage scope) so the popup reappears each session
   *  until the user selects a paid plan. */
  MIGRATION_WELCOME_POPUP_DISMISSED: 'migrationWelcomePopupDismissed',
  PENDING_AUTH_PROVIDER: 'pendingAuthProvider',
} as const;
